<template>
    <div class="login">
        <div class="cnt" v-bind:class="{ 'login': (loading || !(!email && !password || response)) }">
            <img class="logo-milun" src="~@/assets/img/milun.png" />
            <h2 v-if="loading || !(!email && !password || response)">Toni Milun Liga</h2>
            <h2 v-if="!email && !password || response">Pridruži se Toni Milun Ligi i osvoji vrijedne nagrade!</h2>

            <p v-if="loading || !(!email && !password || response)">Molimo pričekajte...</p>
            <p>{{ response }}</p>
            <p v-if="!email && !password || response">Pridruži se najzanimljivijoj Ligi u Hrvatskoj i pokaži što znaš!
                Igrajući Ligu možeš naučiti puno toga i pri tome se odlično zabaviti. A da bi zabava bila još slađa Toni i Algebra pripremili su ti vrijedne nagrade.
                <span class="hashtag">#checkiraj pravila Toni Milun Lige #registriraj se</span> i sretno u novoj avanturi!
            </p>
            <a href="https://tonimilun.hr/novi-racun" class="button-1 red no-arrow" v-if="!email && !password || response"><span>Registriraj se</span></a>
        </div>

        <div class="slider-section" v-if="!email && !password || response">
            <div class="img-wrap">
                <!-- <iframe src='https://player.vimeo.com/video/378984307' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe> -->
            <iframe class="holds-the-iframe" frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
            </div>

            <p class="title">Što je Toni Milun Liga i kako se prijaviti?</p>
            <p class="description">Toni Milun Liga je popularni kviz znanja, a znamo svi znanje je IN. Liga ima 6 pitanja iz 4 područja i to iz matematike, popularne znanosti, engleskog jezika i digitalnog društva. Svaki
                točan odgovor nosi određeni broj bodova, a kako točno igrati Ligu pogledaj u videu.
            </p>

            <div class="img-wrap">
                <iframe src='https://player.vimeo.com/video/363756384' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
            </div>

            <div class="button-wrap">
                <router-link v-on:click.native="sendGA('Probna liga')" to="/probno-pitanje/1" class="button-1 no-arrow red"><span>Probna liga</span></router-link>
                <router-link v-on:click.native="sendGA('Što je liga')" to="/onboarding" class="button-1 no-arrow red"><span>Što je liga?</span></router-link>
                <router-link v-on:click.native="sendGA('Pravila')" to="/pravila" class="button-1 no-arrow red"><span>Pravila</span></router-link>
            </div>
        </div>
    </div>
</template>

<script>
/**
     * login page
     * uses firebase method signInWithEmailAndPassword
     * on success redirect to home
     */
import firebase from 'firebase/app'
// import { isFirstTime } from '../utils/firstTimeUtils'

export default {
    name: 'login',
    data () {
        return {
            email: '',
            password: '',
            errors: {
                password: false,
                email: false
            },
            loading: false,
            btn: 'Login',
            response: ''
        }
    },
    mounted () {
        if (this.$route.query.uname !== undefined) {
            this.email = this.$route.query.uname
        }
        if (this.$route.query.up !== undefined) {
            this.password = this.$route.query.up
        }
        if (this.email && this.password) {
            this.login(this.email, this.password)
        }
    },
    watch: {
        loading (val) {
            this.btn = val === true ? 'Processing...' : 'Login'
        }
    },
    methods: {
        checkForm () {
            this.errors.email = (!this.email || !this.validateEmail(this.email))
            this.errors.password = (!this.password || this.password === '')

            if (!this.errors.email && !this.errors.password) {
                this.login(this.email, this.password)
            }
            return false
        },
        login (email, password) {
            this.loading = true
            firebase.auth().signInWithEmailAndPassword(email, password)
                .then((user) => {
                    this.$store.dispatch('authorize').then(() => {
                        // uncomment code below (as well as import) if onboarding needs to be shown
                        // const firstTime = isFirstTime()
                        // const routeUrl = firstTime ? '/onboarding' : '/home'
                        const routeUrl = '/home'
                        this.$router.replace(routeUrl)
                    })
                })
                .catch((error) => {
                    this.response = 'Neispravno korisničko ime ili lozinka'
                    console.log(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        validateEmail (email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        sendGA (button) {
            // eslint-disable-next-line no-undef
            gtag('event', 'click', {
                'event_category': 'Login',
                'event_label': `${button}`
            })
        }
    }
}
</script>

<style scoped lang="scss">
    .login {
        .cnt {
            padding: 15px;
            background: white;
            border-radius: 12px;
            max-width: 900px;
            margin: 0 auto;
            min-height: 350px;
            width: calc(100% - 32px);
        }
        .logo-milun {
            margin: 5px;
            width: 50px;
        }
        p {
            font-family: "axiforma";
            font-size: 16px;
            line-height: 18px;
            letter-spacing: .3px;
            color: $font-black-color;
            margin-top: 45px;
            a {
                font-weight: bold;
            color: #54ddff;
            }

            .hashtag {
                color: #3d85ce;
            }
        }

        .cnt.login {
            max-width: 360px;
            .logo-milun {
                width: auto !important;
            }
        }

    }

    .slider-section {
        box-shadow: 0px 9px 16px 0px rgba(0,0,0,0.16);
        position: relative;
        display: block;
        background-color: #fff;
        border-radius: 5px;
        text-align: left;
        padding: 14px 12px;
        max-width: 900px;
        margin: 40px auto;
        width: calc(100% - 32px);

        .title {
            font-family: "mPlus";
            font-size: 18px;
            letter-spacing: .2px;
            color: #000;
            margin-bottom: 10px;
            text-align: center;
        }
        .description {
            text-align: center;
            margin-top: 30px;
        }
        .text {
            font-family: "axiforma";
            font-size: 12px;
            line-height: 18px;
            font-weight: 400;
            letter-spacing: .3px;
            color: #737a7f;
            margin: 0;

            a {
                color: #001840;
            }
        }
        .img-wrap {
            position: relative;
            padding-bottom: 55.667%;
            height: 0;
            overflow: hidden;
            max-width: 100%;
            height: auto;
            margin-bottom: 20px;

            iframe, object, embed {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                &.holds-the-iframe {
                    background-image: url('~@/assets/img/1920x1080_otkazano.png');
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: center;
                }
            }
        }
        .partner-wrap {
            position: relative;
            padding-right: 134px;
            margin-bottom: 25px;
            &.full-width {
                padding-right: 0;
            }

            .tag {
                display: block;
                position: absolute;
                width: 111px;
                height: 42px;
                right: 0;
                top: calc(50% - 21.5px);
                background-position: 50%;
                background-size: contain;
                background-repeat: no-repeat;
            }
        }
        .button-wrap {
            display: flex;
            justify-content: space-between;
            text-align: center;
            margin-bottom: 25px;

            .button-1 {
                min-width: 135px;
            }
        }
    }

    @media only screen and (max-width: 495px) {
        .slider-section .button-wrap {
            display: block;

            .button-1 {
                width: 200px;
                margin: 10px;
            }
        }
    }
</style>
